export { default } from './SpotPageMeta';
